// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2DJP-","main-image":"Header_main-image__3WCAu"};